import { render, staticRenderFns } from "./my-corp-data.vue?vue&type=template&id=975c9782&scoped=true&"
import script from "./my-corp-data.vue?vue&type=script&lang=js&"
export * from "./my-corp-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975c9782",
  null
  
)

export default component.exports